<template>
  <div>
    <p class="header">
      <span>{{language.setTimeZone}}</span>
    </p>
    <div class="content">
      <div class="chooseTime">
        <!-- <label class="choose_lable">{{language.selectedTime}}</label> -->
        <div class="current_time">
          {{currentTime}}
        </div>
        <div class="current_date">
          {{currentDate}}
        </div>
      </div>
      <div class="chooseCountry">
        <label class="choose_lable">{{language.timeZone}}</label>
        <Select v-model="areaCodeVal" @on-change="changeAreaCode">
          <Option v-for="(item,index) in areaCodeList" :value="item.zoneid + '&' + item.id + '&' + item.timezone" :key="item.id">{{item.showText}}</Option>
        </Select>
      </div>
    </div>
    <div class="footer">
      <Button type="primary" size="large" long @click="confirmLocation">{{language.confirm}}</Button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: 'locationModal',
  props: ['basicInfo'],
  inject:['reload'],
  data() {
    return {
      language: this.$store.state.language, // 语言
      languageBtn: this.$store.state.languageBtn, // 语言按钮(与词库刚好相反)
      timer: null,
      timer2:null,
      areaCodeString:'Asia/Shanghai',
      currentDate: '',
      currentTime: '',
      areaCodeList: [],
      areaCode: '8',//时区sting
      areaCodeVal:'8&8&Asia/Shanghai',//时区sting+'&'+时区id
    };
  },
  methods: {
    // 确认选择时区
    confirmLocation() {
      this.$post(
        '/institutionUser/modifyUser',
        {
          id: this.basicInfo.id,
          sysUserId:this.basicInfo.sysUserId,
          areaCode: this.areaCodeVal
        },
        0
      )
        .then(res => {
          clearInterval(this.timer);
          clearInterval(this.timer2);
          this.$emit('closeLocationModal');
          this.$Message.success(this.language.locateSuccess);
        })
        .catch(err => {
          this.$Message.error(err.message);
        });
    },
    //选择时区下拉框
    changeAreaCode(val) {
      if(val){
        this.areaCodeStingV = val.split('&')[2]
        this.currentDate = moment(this.$timeChange(new Date(), 2, 2,val.split('&')[2])).format('lll')
        this.currentTime = this.$timeChange(new Date(), 3, 2, val.split('&')[2])
      }
    },
    //通过时区获取当地时间
    // getAreaZone(val = parseInt(this.calendarTimezone)) {
    //     let localTime = this.getLocalTime(parseInt(val)).toString().split(' ');
    //     this.currentTime = localTime[4];
    //     this.currentDate = localTime[0] + ' ' + localTime[1] + ' ' + localTime[2] + ' ' + localTime[3];
    // },
    //时间转换时区封装方法
    // getLocalTime(i) {
    //   //参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
    //   if (typeof i !== 'number') return;
    //   var d = new Date();
    //   //得到1970年一月一日到现在的秒数
    //   var len = d.getTime();
    //   //本地时间与GMT时间的时间偏移差
    //   var offset = d.getTimezoneOffset() * 60000;
    //   //得到现在的GMT+0 (格林威治标准时间)
    //   var utcTime = len + offset;
    //   return new Date(utcTime + 3600000 * i);
    // }
  },
  mounted() {
    this.areaCodeList = this.$store.state.timeZone
    this.areaCodeVal = this.basicInfo.areaCode
    this.currentTime = this.$timeChange(new Date(), 3, 3, this.calendarTimezone)
    this.currentDate = moment(this.$timeChange(new Date(), 1, 3, this.calendarTimezone)).format('LLL')
    this.timer = setInterval(() => {
      if(this.areaCode){
        this.currentTime = this.$timeChange(new Date(), 3, 3, this.defaultZone)
        this.currentDate = moment(this.$timeChange(new Date(), 1, 3, this.defaultZone)).format('LLL')
      }
    }, 1000);
  },
  watch: {
    basicInfo(newVal, oldVal) {
      let defaultZone = 'Asia/Shanghai'
      if(newVal.areaCode&&newVal.areaCode.split('&').length==3){
        defaultZone = newVal.areaCode.split('&')[2]
      }
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if(this.areaCode){
          this.currentTime = this.$timeChange(new Date(), 3, 3, this.defaultZone)
          this.currentDate = moment(this.$timeChange(new Date(), 1, 3, this.defaultZone)).format('LLL')
        }
      }, 1000);
    },
    areaCodeVal(newVal,oldVal){
      let defaultZone = 'Asia/Shanghai'
      if(newVal&&newVal.indexOf('&')&&newVal.split('&').length==3){
        defaultZone = newVal.split('&')[2]
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.currentTime = this.$timeChange(new Date(), 3, 3, defaultZone)
          this.currentDate = moment(this.$timeChange(new Date(), 1, 3, defaultZone)).format('LLL')
        }, 1000);
      }
    }
  },
  computed:{
      calendarTimezone(){
        return this.$store.getters.areaCodeSting
      }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除定时器
    }
    if (this.timer2) {
      clearInterval(this.timer2); // 在Vue实例销毁前，清除定时器
    }
  }
};
</script>

<style lang='stylus' scoped>
.choose_lable
  margin: 10px 0
  display: inline-block
.content
  display: flex
  padding: 20px 0
  justify-content: space-between
  .chooseCountry
    width: 235px
  .chooseTime
    .current_time
      font-size: 28px
      padding: 15px 0
</style>


// WEBPACK FOOTER //
// src/components/locationModal.vue